module.exports = __webpack_public_path__ + "static/sonic-b19d20111e3cf65a64c35459b6cedf22.jpg";